module.exports = __webpack_public_path__ + "static/media/up-3door.26f1454b.png";